import React from "react";
import {
  Box,
  CircularProgress,
  Backdrop,
  Typography,
  Fade,
} from "@mui/material";

interface FullScreenLoadingProps {
  message?: string;
}

const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({
  message = "Loading...",
}) => {
  return (
    <Fade in={true} timeout={300}>
      <Backdrop
        open={true}
        sx={{
          background: "rgba(255, 255, 255, 0.5)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress size={30} color="primary" />
          {message && (
            <Typography
              variant="body2"
              sx={{
                mt: 1.5,
                color: "primary.main",
                fontWeight: "medium",
                textShadow: "0px 0px 4px rgba(255,255,255,0.7)",
              }}
            >
              {message}
            </Typography>
          )}
        </Box>
      </Backdrop>
    </Fade>
  );
};

export default FullScreenLoading;
